import React from 'react';
import { alpha, Backdrop } from '@mui/material';

import { Loading as LocalLoading } from '@ocx/ui';

type LoadingProps = {
  open: boolean;
};

export const Loading: React.FC<LoadingProps> = (props) => {
  const { open } = props;

  return (
    <Backdrop
      sx={(theme) => ({
        background: alpha(theme.palette.background.paper, 0.3),
        zIndex: theme.zIndex.fab + 2, // to display loader on top of "Search" field and "List view"
      })}
      open={open}
      unmountOnExit>
      <LocalLoading />
    </Backdrop>
  );
};
